import { forEach } from "lodash";
import {
    IApiApplicationCreate,
    IApiApplicationDetails,
    IApiClientData,
    IApiQuoteGroupVisitor,
    IApiDisclosure,
    IApiResponseQuestion
} from "../../interfaces/IApiAppFormData";
import {
    IAFQuestionData,
    IApplicantList,
    IApplications,
    IApplicationInfo,
    IContactInfo,
    IDisclosure,
    IApplicantInfo,
    IApplicationProgress
} from "../../interfaces/IAppFormData";

export const parseQuestions = (question: IApiResponseQuestion): IAFQuestionData => {
    const questions = question?.data?.question?.map((question) => ({
        id: question?.smartHealthQuestion?.id,
        disclosures: question?.smartHealthQuestion?.disclosures,
        availableQuestionAnswers: question?.smartHealthQuestion?.availableQuestionAnswers,
        answer: question?.smartHealthQuestion?.answer,
        dateFormat: question?.smartHealthQuestion?.dateFormat,
        unit: question?.smartHealthQuestion?.unit,
        questionText: question?.smartHealthQuestion?.questionText,
        disclosureName: question.disclosureName,
        questionHeaderText: question?.smartHealthQuestion?.questionHeaderText,
        questionHeaderHelp: question?.smartHealthQuestion?.questionHeaderHelp,
        questionTypeParameter: parseInt(
            question?.smartHealthQuestion?.questionTypeParameter
        ),
        questionNumber: question?.smartHealthQuestion?.questionNumber,
        questionParameter: question?.smartHealthQuestion?.questionParameter,
        questionType: question?.smartHealthQuestion?.questionType,
        helpText: question?.smartHealthQuestion?.helpText,
        rangeStart: question?.smartHealthQuestion?.rangeStart,
        rangeEnd: question?.smartHealthQuestion?.rangeEnd,
        questionLabel: question?.digitalAdviceQuestion?.label,
        controlTypeId: question?.digitalAdviceQuestion?.controlTypeId,
        controlTypeName: question?.digitalAdviceQuestion?.controlTypeName,
        clearsChecklist: question?.smartHealthQuestion?.clearsChecklist
    }));

    return {
        questions,
        response: question?.data?.response,
        isSuccessful: question?.isSuccessful,
        complete: question?.data?.complete || false,
        halt: question?.data?.halt || false,
        haltReasons: question?.data.haltReasons
    };
};

export const parseUserList = (data: IApiClientData): IApplicantList => {
    const applicants = data?.quoteGroupPersons.map((info, idx) => ({
        personId: info?.client?.personId,
        age: info?.client?.age,
        gender: info?.client?.gender,
        isSmoker: info?.client?.isSmoker,
        isChild: info?.client?.isChild,
        params: `applicant${idx + 1}`,
        label: `Applicant ${idx + 1}`,
        clientNumber: idx + 1
    }));

    return {
        applicants,
        digitalAdviceSessionUserID: data?.digitalAdviceSessionUserID
    };
};

export const augmentApplicantData = (progressInfo: IApplicationProgress): IApplicationProgress => {
    var applicants = progressInfo.applicants;
    forEach(applicants, applicant => {
        applicant.params = `applicant${applicant.clientNumber}`;
        applicant.personId = applicant.applicantId;
        applicant.label = `Applicant ${applicant.clientNumber}`;
    });
    return progressInfo;
};

export const parseContactInfo = (data: IApiQuoteGroupVisitor): IContactInfo => {
    return {
        clientId: data?.mainClientId,
        name: data?.contactInfo?.name,
        email: data?.contactInfo?.email
    };
};

export const parseApplication = (data: IApiApplicationCreate): IApplicationInfo => {
    return {
        applicationToken: data?.result?.applicationToken,
        applicants: data?.result?.applicants || []
    };
};

export const parseApplicationDetails = (data: IApiApplicationDetails): IApplications => {
    const applicants: IApplicantInfo[] = data?.applicants.map((a) => ({
        ...a,
        personId: a.applicantId,
        params: `applicant${a.clientNumber}`,
        label: `Applicant ${a.clientNumber}`,
        isCompleted: false,
    }));
    return {
        applicationId: data?.applicationId,
        applicationToken: data?.applicationToken,
        applicants
    };
};

export const parseDisclosure = (res: IApiDisclosure): Array<IDisclosure> => {
    return res?.data?.result?.disclosures?.map((item) => ({
        disclosure: item.disclosure,
        disclosureId: item.disclosureId
    }));
};
